module.exports = __webpack_public_path__ + "0af85005dbbb1cf00ea4fb5aac53a7e4.pdf";